export default Object.freeze({
  PreRegistry: 125,
  Registry: 126,
  Evaluated: 127,
  Served: 128,
  NotEligible: 129,
  Egress: 131,
  Available: 200,
  Inactive: 219,
  Eligible: 303,
});
